import * as React from 'react';
import { fetchGrupoPlanes } from '../../actions/planesActions';
import { connect } from 'react-redux';
import { postAdministracionTiposPublicacion, postTiposPublicacionAsociarGrupoPlanes } from '../../api/axios';
import { setTiposPublicacion, setTiposGrupoPlanes, resetTiposPublicacion } from '../../actions/tiposPublicacionActions';
import Cleave from 'cleave.js/react';
import { toast } from 'react-toastify';
import GoBackArrow from '../General/GoBackArrow';
import { withNavigation } from '../General/withNavigation';

class TipoPublicacionesNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            descripcion: "",
            comision: '',
            cantidadCuotas: 0,
            gruposDePlanes: [],
            cantidadCuotas: 0,

        };
        this.descripcionInputRef = React.createRef();
    };

    componentDidMount() {
        this.busquedaGrupoPlanes({ numeroPagina: 1, cantidadPagina: 10 });
        this.setState({
            descripcion: this.props.setTipoPublicacion.descripcion || '',
            comision: this.props.setTipoPublicacion.comision || '',
            cantidadCuotas: this.props.setTipoPublicacion.cantidadCuotas || 0
         });

        if (this.descripcionInputRef.current) {
            this.descripcionInputRef.current.focus();
        }
    }

    changeCheck = (params) => {
        this.addToPlanes(params);
    }

    clickFila = (params) => {
        this.addToPlanes(params);
    }

    addToPlanes = (params) => {
        let arrayEstado = [];
        arrayEstado = this.state.gruposDePlanes;
        let repetido = arrayEstado.some(x => x == params.idGrupoPlan);

        if (repetido) {
            let index = arrayEstado.findIndex(x => x == params.idGrupoPlan);
            if (index !== undefined) {
                arrayEstado.splice(index, 1);
                this.setState({ gruposDePlanes: arrayEstado });
                document.getElementById("check" + params.idGrupoPlan).checked = false;
            }
        }
        else {
            arrayEstado.push(params.idGrupoPlan);
            this.setState({ gruposDePlanes: arrayEstado });
            document.getElementById("check" + params.idGrupoPlan).checked = true;
        }
    }

    busquedaGrupoPlanes = (request) => {
        let params = request;

        if (!this.props.userType.isAdminMod) {
            params = { ...request, idSeller: this.props.idSeller };
            this.props.fetchGrupoPlanes({ params });
        } else {
            this.props.fetchGrupoPlanes({ params });
        }
    }

    onSubmit = async (event) => {
        event.preventDefault();
        let data = {
            descripcion: this.props.setTipoPublicacion.descripcion,
            comision: parseFloat(this.props.setTipoPublicacion.comision),
            cantidadCuotas: parseInt(this.props.setTipoPublicacion.cantidadCuotas)
        }
       
        if (Object.keys(this.props.setTipoPublicacion).length == 1 || this.props.setTipoPublicacion.descripcion == "" || this.props.setTipoPublicacion.comision == "" || JSON.stringify(this.props.setTipoPublicacion) == "{}") {
            if (JSON.stringify(this.props.setTipoPublicacion) == "{}" || Object.keys(this.props.setTipoPublicacion).length == 1) {
                toast.error("Debe agregar una descripción");
                toast.error("Debe agregar una comisión");
            }
            if (this.props.setTipoPublicacion.descripcion == "") {
                toast.error("Debe agregar una descripción");
            }
            if (this.props.setTipoPublicacion.comision == "") {
                toast.error("Debe agregar una comisión");
            }
            if (this.props.setTipoPublicacion.cantidadCuotas == "") {
                toast.error("Debe agregar un número de cuotas válido");
            }
            return;
        }

        let postTipo = postAdministracionTiposPublicacion(data);

        postTipo.then(res => {
            toast.success("Tipo publicacion guardada");
            this.asociarGrupoPlanes(res.data.idTipoPublicacion);
            this.goToTipoPublicaciones();
        }).catch(err => {
            toast.error("No pudo crearse");
            // (err.response.data.errores) ? err.response.data.errores.forEach(error => toast.error(error)) : toast.error("No pudo crearse");
        });

    }

    asociarGrupoPlanes = (id) => {
        let elementIdGrupo = null;
        let arrayIdsElement = [];
        for (let index = 0; index < this.props.tiposGruposPlanes.length; index++) {
            elementIdGrupo = this.props.tiposGruposPlanes[index].idGrupoPlan;
            arrayIdsElement.push(elementIdGrupo);
        }
        let data = {
            idTipoPublicacion: id,
            listaIdsGrupoPlanes: arrayIdsElement
        }

        let asociarGrupoPlanes = postTiposPublicacionAsociarGrupoPlanes(data)
        asociarGrupoPlanes.then(res => {
            toast.success("Se asociaron grupos de planes");
        }).catch(err => {
            // toast.error("No se seleccionaron grupos de planes")
        });
    }

    inputChange = (e) => {
        var numbersOnly = /^[0-9.]+$/;
        let valor = e.target.value;
        
        
        if (e.target.name == "comision" || e.target.name == "cantidadCuotas") {
            let esNumero = valor.match(numbersOnly);
            if (esNumero == null) {
                document.getElementById("comisionId").value = "";
                this.setState({ cambioInputChange: true });
                return;
            }
            if (e.target.value > 100) {
                document.getElementById("comisionId").value = "";
                this.setState({ cambioInputChange: true });
            } else {
                this.setState({ cambioInputChange: true });
                let estado = { ...this.props.setTipoPublicacion, [e.target.name]: valor }
                this.props.setTiposPublicacion(estado);
            }
        } else {
            let estado = { ...this.props.setTipoPublicacion, [e.target.name]: valor }
            this.props.setTiposPublicacion(estado);
        }
    }

    goToBusqueda = () => {
        this.props.navigate("/Tipo/Publicaciones/GrupoPlanes/Busqueda");
    }

    goToTipoPublicaciones = () => {
        this.props.navigate("/Tipo/Publicaciones");
    }

    borrarFila = (idGrupoPlan) => {
        let grupoPlanes = JSON.stringify(this.props.tiposGruposPlanes);
        if (grupoPlanes != "[]") {
            let index = this.props.tiposGruposPlanes.findIndex(x => x.idGrupoPlan == idGrupoPlan);
            this.props.tiposGruposPlanes.splice(index, 1);
            this.props.setTiposGrupoPlanes(this.props.tiposGruposPlanes);
            this.forceUpdate();
        }

    }

    tablaGrupos = () => {
        let jsonData = JSON.stringify(this.props.tiposGruposPlanes)
        if (jsonData != "[]" && jsonData != undefined) {
            var rows = [];
            let htmlData;
            this.props.tiposGruposPlanes.map((item) => {
                htmlData = <tr className="hover-background-color">
                    <td class="div-center">{item.idGrupoPlan}</td>
                    <td>{item.descripcion}</td>
                    <td class="div-center"><small className=" font-14  applyFont">{item.comision}<i className="fas fa-percent"></i></small></td>
                    <td onClick={() => this.borrarFila(item.idGrupoPlan)}><i class="fas fa-trash-alt"></i></td>
                </tr>
                rows.push(htmlData);
            });
            return rows;
        }
    }



    render() {
        let descripcion, comision, cantidadCuotas
        if (!this.state.cambioInputChange) {
            comision = this.state.comisionPredeterminada;
           
        } else {
            descripcion = this.props.setTipoPublicacion.descripcion != undefined ? this.props.setTipoPublicacion.descripcion : this.props.tipoPublicacion.descripcion;
            comision = this.props.setTipoPublicacion.comision != undefined ? this.props.setTipoPublicacion.comision : this.props.tipoPublicacion.comision;
            cantidadCuotas = this.props.setTipoPublicacion.cantidadCuotas
        }
        return (

            <div className="container">
                <div className="row align-items-center">
                    <div className="card">
                        <div className="col-12 mt-4">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="col-10 col-md-5 mb-4">
                                    <GoBackArrow />
                                    <h4 className="card-title d-block d-sm-inline mb-0 ms-1">Crear Tipo de Publicaciones</h4>
                                </div>
                                <button type="button" onClick={this.goToBusqueda} className="btn btn-sm btn-green m-r-10">
                                    <i className="fa fa-plus-circle mx-1"></i>Seleccionar grupos
                                </button>
                            </div>


                            <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>
                                <div className="tab-content">

                                    <div className="button-group align-self-center text-right d-none d-md-block">

                                    </div>

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <label className="label-oscura">Descripción</label>
                                                <input
                                                    name="descripcion"
                                                    value={this.props.setTipoPublicacion?.descripcion ?? ''}
                                                    onChange={this.inputChange}
                                                    type="text" id="firstName"
                                                    class="form-control"
                                                    ref={this.descripcionInputRef}
                                                />
                                            </div>
                                            <div class="col-md-4">
                                                <small className=" font-14  applyFont"><i className="fas fa-percent"></i></small>
                                                <label className="label-oscura">&ensp;Comisión</label>
                                                <Cleave
                                                    className="form-control"
                                                    id="comisionId"
                                                    name="comision"
                                                    value={this.props.setTipoPublicacion?.comision ?? ''}
                                                    onChange={this.inputChange}
                                                    // value={this.state.comision == 100 ? 100 : this.state.comision}
                                                    // onKeyUp={this.inputChange}
                                                    options={{ blocks: [5], numericOnly: false }}
                                                />
                                            </div>
                                            <div class="col-md-4">
                                                <label className="label-oscura">N° Cuotas</label>
                                                <Cleave
                                                    name="cantidadCuotas"
                                                    value={this.props.setTipoPublicacion?.cantidadCuotas ?? ''}
                                                    onChange={this.inputChange}
                                                    id="comisionId"
                                                    className="form-control"
                                                    options={{ blocks: [3], numericOnly: true }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {this.props.tiposGruposPlanes.length > 0 &&
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th className="div-center">ID</th>
                                                <th>Descripción</th>
                                                <th className="div-center">Comisión</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.tablaGrupos()
                                            }
                                        </tbody>
                                    </table>
                                }

                                <div className="d-flex justify-content-center">
                                    <button onClick={this.onSubmit} type="submit" className="btn btn-sm btn-green waves-light m-r-10">Guardar</button>
                                    <button onClick={this.goToTipoPublicaciones} className="btn btn-sm background-rojo-megatone waves-effect waves-light">Cancelar</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        );
    }

}


const mapStateToProps = state => ({
    userType: state.general.userType,
    idSeller: state.general.idSeller,
    grupoPlanes: state.planes.grupoPlanes.elementos,
    setTipoPublicacion: state.tiposPublicacion.setTiposPublicacion,
    tiposGruposPlanes: state.tiposPublicacion.tiposGruposPlanes,
    resetTiposPublicacion: state.tipoPublicacion
});
export default withNavigation(connect(mapStateToProps, {
    fetchGrupoPlanes,
    setTiposPublicacion,
    setTiposGrupoPlanes,
    resetTiposPublicacion
})(TipoPublicacionesNew));